import {combineLatest} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {spots$} from '@/config';
import {spot$} from '@/state/spot';
import {displayAllSpotSymbols$} from '@/state/spot-all-symbols';
import {convertConditionalOrderData} from '@/spot-utils/order-data';
import {spotConditionalOrdersCache$} from './order-conditional-spot-cache';
import type {ws} from '@/types';
type OpenSpotOrderRaw = ws.OpenSpotOrderRaw;
type ClosedSpotOrderRaw = ws.ClosedSpotOrderRaw;

type ConditionalOrderRaw = OpenSpotOrderRaw | ClosedSpotOrderRaw;

const orderRaws$ = spotConditionalOrdersCache$.pipe(
  map((cache: Map<string, ConditionalOrderRaw>): ConditionalOrderRaw[] => cache.toArray())
);

export const spotConditionalOrderData$ = combineLatest([orderRaws$, spots$, spot$, displayAllSpotSymbols$]).pipe(
  filter(([, , spot]) => spot.mode === 'Spot'),
  map(([orderRaws, spots, spot, displayAllSpotSymbols]) =>
    convertConditionalOrderData<ConditionalOrderRaw>(orderRaws, spots, spot, displayAllSpotSymbols)
  )
);
